import { render } from "./AppSpacer.vue?vue&type=template&id=5d8d5c9c&scoped=true"
import script from "./AppSpacer.vue?vue&type=script&lang=js"
export * from "./AppSpacer.vue?vue&type=script&lang=js"

import "./AppSpacer.vue?vue&type=style&index=0&id=5d8d5c9c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8d5c9c"]])

export default __exports__